import { Link, useLocation } from 'react-router-dom'
import React from 'react'
import { t } from 'ttag'
import { useDispatch, useSelector } from 'react-redux'
import { AutoSizer, InfiniteLoader, List, WindowScroller } from 'react-virtualized'
import PropTypes from 'prop-types'



import SearchResponseItem from './SearchResponseItem'
import ClusterRecommendation from './recommendations/ClusterRecommendation'
import FilterBar from './FilterBar'
import CollegeRecommendation from './recommendations/CollegeRecommendation'
import RelatedItemRecommendation from './recommendations/RelatedItemRecommendation'

import * as h2Api from '../../h2Api'
import LoadingIndicator from '../LoadingIndicator'
import {
  removeForComparison as removeCollegeForComparison,
  selectForComparison as selectCollegeForComparison
} from '../../actions/colleges'
import {
  removeForComparison as removeJobForComparison,
  selectForComparison as selectJobForComparison
} from '../../actions/jobsearch'
import {
  removeForComparison as removeMilitaryForComparison,
  selectForComparison as selectMilitaryForComparison
} from '../../actions/military'
import { removeForComparison, selectForComparison } from '../../actions/occupationProfile'
import ComparisonFooter from '../ComparisonFooter'
import { removeMajorForComparison, selectMajorForComparison } from '../../actions/majors'
import { clearQueryParams, updateUrlWithFirstResultInWindow } from '../../actions/search'




class SearchScroller extends React.PureComponent {
  state = {
    renderTrigger: 0,
    top: 0,
    bottom: 10
  }

  rowRenderer = r => {
    //

    const rslt = this.props.resultRows ? this.props.resultRows?.results[r.index] : null

    //

    if (!rslt) {
      return null
    }

    const selectedMap = {}

    this.props.selected.forEach(k => (selectedMap[k] = true))

    //

    return (
      <div role="row" key={`search-result-${rslt.id}`} style={r.style}>
        <SearchResponseItem
          item={rslt}
          selectedMap={selectedMap}
          isSelectedForComparison={this.props.isItemSelectedForComparison(rslt)}
          onSelectForComparison={this.props.selectItemForComparison}
          showCompareCheckbox={!!this.props.typeForComparison()}
        />
      </div>
    )
  }

  isRowLoaded = props => {
    //

    const { index } = props
    //

    const loaded = this.props.resultRows?.results.length > index

    /*
     *
;
     * return true
     */
    return loaded
  }

  loadMoreRows = ({ startIndex, stopIndex }) => {
    //
;
    const { loadMoreRows } = this.props

    this.setState({
      ...this.state,
      renderTrigger: this.state.renderTrigger + 1
    })

    return this.props.dispatch(loadMoreRows(startIndex, stopIndex))
  }

  calcNumRows = () => {
    const resultCount = this.props.resultCount

    //

    if (resultCount && !isNaN(resultCount)) {
      return parseInt(resultCount)
    }

    return 0
  }

  render = () => {
    const numRows = this.calcNumRows()
    const listRowCount = this.props.resultRows?.results.length ?? numRows
    //

    const moreProps = this.props.firstResult
      ? {
          scrollToIndex: this.props.firstResult
        }
      : {}

    //


    return (
      <AutoSizer disableHeight>
        {({ width }) => {
          return (
            <InfiniteLoader
              isRowLoaded={props => this.isRowLoaded(props)}
              loadMoreRows={props => this.loadMoreRows(props)}
              minimumBatchSize={this.props.searchRequest.result?.itemsPerPage || 250}
              rowCount={numRows}
              threshold={50}>
              {({ onRowsRendered, registerChild }) => (
                <WindowScroller>
                  {({ height, isScrolling, onChildScroll, scrollTop }) => {
                    return (
                      <List
                        width={width}
                        height={height}
                        autoHeight
                        isScrolling={isScrolling}
                        onScroll={onChildScroll}
                        scrollTop={scrollTop}
                        style={{ outline: 'none' }}
                        overscanRowCount={5}
                        estimatedRowSize={numRows}
                        rowCount={listRowCount}
                        rowHeight={this.props.rowHeight}
                        rowRenderer={this.rowRenderer.bind(this)}
                        onRowsRendered={p => {
                          const { startIndex, stopIndex } = p

                          this.props.updateOffsetParam(startIndex)
                          this.setState({
                            ...this.state,
                            top: startIndex,
                            bottom: stopIndex
                          })
                          onRowsRendered(p)
                        }}
                        ref={registerChild}
                        renderTrigger={this.state.renderTrigger}
                        {...moreProps}
                      />
                    )
                  }}
                </WindowScroller>
              )}
            </InfiniteLoader>
          )
        }}
      </AutoSizer>
    )
  }
}

SearchScroller.propTypes = {
  resultRows: PropTypes.object,
  selected: PropTypes.array,
  selectItemForComparison: PropTypes.func,
  isItemSelectedForComparison: PropTypes.func,
  typeForComparison: PropTypes.func,
  loadMoreRows: PropTypes.func,
  dispatch: PropTypes.func,
  resultCount: PropTypes.number,
  firstResult: PropTypes.number,
  searchRequest: PropTypes.object,
  updateOffsetParam: PropTypes.func,
  rowHeight: PropTypes.number
}

const SearchContainer = ({
  resultRows,
  searchFilterModel,
  loadMoreRows,
  searchRequest,
  searchFilterFormName,
  searchFilterForm
}) => {
  const filtersClearable = searchRequest.result?.filtersClearable
  //const qs = useQuery()
  const location = useLocation()
  const firstResult = null
  const dispatch = useDispatch()
  const typeForComparison = () => {
    const singleType = searchRequest.result?.singleType || false
    const singleTypeName = searchRequest.result?.singleTypeName


    if (singleType) {
      return singleTypeName
    }

    const types = searchRequest.searchResponse?.alternateTypes
      ?.flatMap(t => t.mode)
      .filter(m => m !== 'all')

    return types?.length == 1 ? types[0] : null
  }
  const selected = useSelector(state => {
    switch (typeForComparison()) {
      case 'college':
        return state.college.comparison.selectedInstitutions

      case 'major':
        return state.college.majorComparisonItems.selectedMajors

      case 'joborders':
        return state.jobs.comparison.selected

      case 'moc':
        return state.military.comparison.selected

      default:
        return state.occupations.comparison.selectedOccupations
    }
  })


  /*
   *

   *

   */
  const hasRecommendations = recommendations => {
    return recommendations && recommendations?.length > 0
  }
  const outputRecommendations = recs => {
    if (!hasRecommendations(recs)) {
      return null
    }

    return recs.map((recommendations, idx) => {
      //

      switch (recommendations.type) {
        case 'cluster_by_occupation':
          return (
            <ClusterRecommendation
              key={t`cluster-recommendation-${idx}`}
              recommendations={recommendations}
            />
          )
        case 'college_by_major':
          return (
            <CollegeRecommendation
              key={t`college-recommendation-${idx}`}
              recommendations={recommendations}
            />
          )
        case 'similar_by_result':
          return (
            <RelatedItemRecommendation
              key={t`related-recommendation-${idx}`}
              recommendations={recommendations}
            />
          )
        default:
          return (
            <div
              className="recommendations col-sm-3"
              key={t`other-recommendation-${idx}`}>
              <ul className="recommendation-listing">
                {recommendations?.items?.map(r => (
                  <li key={r.url}>
                    <div className="inlist-recommendation">
                      <Link to={r.url}>{r.title}</Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )
      }
    })
  }
  //

  const searchResponse = searchRequest?.result
  const recommendations = searchResponse?.recommendations
  const resultCount = searchResponse?.totalHits?.toLocaleString() ?? t`no`
  //const resultsHiddenByFilter = searchResponse?.numHiddenByFilter > 0 ?? false
  const selectItemForComparison = (itm, evnt) => {
    //

    switch (itm.resultType) {
      case 'major':
        if (evnt.target.checked) {
          dispatch(selectMajorForComparison(itm.id))
        } else {
          dispatch(removeMajorForComparison(itm.id))
        }

        break

      case 'college':
        if (evnt.target.checked) {
          dispatch(selectCollegeForComparison(itm.id))
        } else {
          dispatch(removeCollegeForComparison(itm.id))
        }

        break

      case 'occupation':
        if (evnt.target.checked) {
          dispatch(selectForComparison(itm.id))
        } else {
          dispatch(removeForComparison(itm.id))
        }

        break

      case 'joborders':
        if (evnt.target.checked) {
          dispatch(selectJobForComparison(itm.id))
        } else {
          dispatch(removeJobForComparison(itm.id))
        }

        break
      case 'moc':
        if (evnt.target.checked) {
          dispatch(selectMilitaryForComparison(itm.id))
        } else {
          dispatch(removeMilitaryForComparison(itm.id))
        }

        break
      default:

    }
  }
  const isItemSelectedForComparison = itm => {
    switch (itm.resultType) {
      case 'occupation':
      case 'joborders':
      case 'college':
      case 'major':
      case 'moc':
        return selected.includes(itm.id)
      default:
        return false
    }
  }
  const rowHeight = 170
  const updateOffsetParam = updateUrlWithFirstResultInWindow(location)
  const scrollerProps = {
    resultRows,
    searchRequest,
    searchFilterFormName,
    selected,
    searchFilterForm,
    dispatch,
    selectItemForComparison,
    isItemSelectedForComparison,
    typeForComparison,
    loadMoreRows,
    firstResult,
    updateOffsetParam,
    rowHeight
  }
  const filterDescription = searchRequest.result?.filterDescriptionStatement
  const filtersFromResponse = searchRequest.result?.filters
  //const filtersApplied = filtersFromResponse?.some(f => f.isApplied)
  const scrolledSummaryText = t`${resultCount} results found ${filterDescription}`

  /*
   *

   *

   */
  return (
    <div className="container search-results-container">
      <FilterBar
        searchResponse={searchResponse}
        filtersFromResponse={filtersFromResponse}
        isLoading={!h2Api.receivedResponse(searchRequest)}
        hasRecommendations={hasRecommendations(recommendations)}
        searchFilterFormModel={searchFilterModel}
        searchFilterForm={searchFilterForm}
        scrolledSummaryText={scrolledSummaryText}
        maxWindowHeight={searchResponse?.totalHits * rowHeight}
        searchFilterFormName={searchFilterFormName}
      />
      <div className="row response-container">
        <div
          className={`results sitesearch ${
            hasRecommendations(recommendations) ? 'col-sm-9' : 'col-sm-12'
          }`}>
          {h2Api.receivedResponse(searchRequest) && (
            <div>
              <h4 style={{ textAlign: 'center' }} role="status" aria-live="polite">
                {t`${resultCount} results found `}
              </h4>

              {filterDescription || filtersClearable ? (
                <p
                  className="text-center"
                  style={{ fontSize: '.9rem', marginTop: '-15px' }}>
                  {filterDescription}
                  {filtersClearable ? (
                    <button
                      className="btn btn-text"
                      style={{ padding: 0 }}
                      aria-label={t`Clear filters`}
                      onClick={() => {
                        dispatch(clearQueryParams(searchFilterForm, searchFilterFormName))
                      }}>
                      <i className="times"></i>
                    </button>
                  ) : (
                    ''
                  )}
                </p>
              ) : null}
            </div>
          )}
          <style type="text/css">
            {`ul .ReactVirtualized__Grid__innerScrollContainer,
                         ul .ReactVirtualized__List { overflow: visible !important}`}
          </style>
          <div style={{ minHeight: '30vh', focus: 'none' }}>
            {!h2Api.receivedResponse(searchRequest) ? (
              <LoadingIndicator newSiteLook={dynamicValues.newSiteLook} />
            ) : (
              <SearchScroller
                {...scrollerProps}
                resultCount={searchResponse?.totalHits ?? 0}
              />
            )}
          </div>
        </div>
        {h2Api.receivedResponse(searchRequest) && outputRecommendations(recommendations)}
      </div>
      <ComparisonFooter
        location={location}
        compareType={typeForComparison()}
        showComparison={true}
      />
    </div>
  )
}

SearchContainer.propTypes = {
  resultRows: PropTypes.object,
  searchRequest: PropTypes.object,
  searchFilterFormName: PropTypes.string,
  searchFilterModel: PropTypes.object,
  searchFilterForm: PropTypes.object,
  loadMoreRows: PropTypes.func
}

export { SearchContainer }
